export enum ImportSystemObjectType {
    User = 1,
    Unit = 2,
}

export const ImportSystemObjectTypes = [
    { Id: ImportSystemObjectType.User, TextId: 'user.user' },
    { Id: ImportSystemObjectType.Unit, TextId: 'common.unit' },
];
